import { Col, Row, Select, Switch } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../../../application/store';
import {
	setEventFilter,
	setSelectedEvent,
} from '../../../../slices/Customer/eventFilterSlice';

import { BookedForSalesEventSummary } from '../../../../api-client';
import { useBookedForSales } from '../../hooks/useBookedForSales';

import './bv-switch-event-view.scss';

interface IBVSwitchEventView {
	events: BookedForSalesEventSummary[];
	eventsLoading: boolean;
}

const BVSwitchEventView: React.FC<IBVSwitchEventView> = (props) => {
	const handleSelectChange = (value: string) => {
		dispatch(setSelectedEvent(value));
	};

	const dispatch = useDispatch();

	const { handleExpiringBookedForSales, expiringBookedForSales } =
		useBookedForSales();

	const showEventFilter = useSelector(
		(state: RootState) => state.eventFilter.showEventFilter,
	);
	const selectedEvent = useSelector(
		(state: RootState) => state.eventFilter.selectedEvent,
	);
	const bvSalesAgent = useSelector(
		(state: RootState) => state.system.salesAgent,
	);
	const bvSalesGroup = useSelector(
		(state: RootState) => state.system.salesGroup,
	);
	const handleOnChange = (isChecked: boolean) => {
		dispatch(setEventFilter(isChecked));
		handleExpiringBookedForSales(bvSalesAgent, bvSalesGroup);
	};

	useEffect(() => {
		if (props.events?.length && !selectedEvent) {
			dispatch(setSelectedEvent(props.events[0].id?.toString() ?? ''));
			handleExpiringBookedForSales(bvSalesAgent, bvSalesGroup);
		}
	}, [dispatch, props.events, selectedEvent]);

	return (
		<React.Fragment>
			<Row>
				<Col span={12}>
					<div className="switch-labels-container">
						<div className="switch-wrapper">
							<Switch
								checked={showEventFilter}
								onChange={handleOnChange}
								disabled={!props.events || props.events.length === 0}
							/>
							<span className="label">HE Event View</span>
						</div>
						{showEventFilter ? (
							<span className="brand-event label">Brand Event:</span>
						) : null}
					</div>
				</Col>
				<Col span={12} style={{ textAlign: 'right' }}>
					{!showEventFilter &&
						expiringBookedForSales &&
						expiringBookedForSales.length > 0 && (
							<div className="reminder-wrapper">
								<span className="expiring-bfs-label label">
									Expiring Booked For Sale:
								</span>
								<span className="expiring-bfs-value">
									{expiringBookedForSales.length}
								</span>
							</div>
						)}
					{showEventFilter && (
						<span className="select-wrapper">
							<Select value={selectedEvent} onChange={handleSelectChange}>
								{props.events?.map((events: BookedForSalesEventSummary) => (
									<Select.Option
										key={events.id}
										value={events.id?.toString() ?? ''}
									>
										{events.name}
									</Select.Option>
								))}
							</Select>
						</span>
					)}
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default BVSwitchEventView;
